module.exports = __webpack_public_path__ + "static/media/triangle-l.92331701.svg";